import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loadable from "react-loadable";

import { Channel, DialogType, Topic } from "../../constants";
import { EmptyComponent } from "../common/EmptyComponent";
import { MessageBrokerUtils } from "../../utils";
import UISelectors from "../../redux/selectors/uiSelectors";
import { UIActionCreators } from "../../redux/action-creators";
import { useNoScroll } from "../../hooks";

let dialogSubscription = undefined;

const setPopupCss = () => {
  import(/* webpackChunkName: "popup/index" */ "./CSS/popupRoot.scss");
};

const getPopupTemplate = type => {
  let popupTemplate = null;

  try {
    popupTemplate = Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "popup/[request]" */

          `./Layouts/${type}Popup`
        ),
      loading: EmptyComponent
    });
  } catch (ex) {
    console.log("[POPUP] Cannot find specified popup UI");
    console.error(ex);
  }

  return popupTemplate;
};

const Popup = () => {
  const dispatch = useDispatch();

  const [popupTemplate, setPopupTemplate] = useState({ Popup: null });
  const [popupProps, setPopupProps] = useState({ options: null });

  const popupsDisabled = useSelector(UISelectors.popupsDisabled);
  const isPopupVisible = useSelector(UISelectors.isPopupVisible);

  const setPopupVisibility = useCallback(
    isVisible => {
      dispatch(UIActionCreators.setPopupVisibility(isVisible));
    },
    [dispatch]
  );

  const hidePopup = useCallback(() => {
    setPopupVisibility(false);
    setPopupTemplate({ Popup: null });
    setPopupProps({ options: null });
  }, [setPopupVisibility, setPopupTemplate, setPopupProps]);

  const onDialogShow = useCallback(
    ({ dialogType, options }) => {
      if (dialogType && !popupsDisabled) {
        const isHideDialog = dialogType === DialogType.Hide;

        if (!isHideDialog) setPopupCss();

        setPopupTemplate({
          Popup: isHideDialog ? null : getPopupTemplate(dialogType)
        });
        setPopupProps({ options: isHideDialog ? null : options });
        setPopupVisibility(!isHideDialog);
      }
    },
    [popupsDisabled, setPopupVisibility]
  );

  useEffect(() => {
    dialogSubscription = MessageBrokerUtils.subscribe({
      channel: Channel.UI,
      topic: Topic.DialogShow,
      callback: onDialogShow
    });

    return () => {
      dialogSubscription?.unsubscribe();
    };
  }, [onDialogShow]);

  useNoScroll("popup", isPopupVisible);

  const { Popup } = popupTemplate;

  if (!isPopupVisible || !Popup) return null;

  const props = Object.assign({}, popupProps, { hidePopup });

  return <Popup {...props} />;
};

export default React.memo(Popup);
